<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';

export default {
    init: async (payload) => {
        payload.filter();

        let responseCertifies = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.parts.certifies.list}`);
        payload.certifies = responseCertifies.data.results;
    },
    methods:{
        filter: function(){
            let state = this;
            state.items = [];
            setTimeout(async function(){
              let trucker = (await Request.do(state, 'POST', Request.getDefaultHeader(state), state.data,`${Endpoints.reports.truck.expiredCertifie}`));
                if (trucker.status==200){
                    state.items = trucker.data.results; 
                    console.log(state.items);   
                }
                 state.json_data= state.items;
        }, 100);
        },
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>